import utils from 'utils';
class listBannerCtrl {
  constructor($scope, operationService) {
    // 查询的参数
    $scope.queryParam = {
      pageSize: 10,
      pageNum: 1,
      param: {
        quarter: utils.getQuarter(),
      },
    };
    let activeSel = function () {
      if (operationService.hasPermit('balance_sheet')) {
        return 1;
      }
      if (operationService.hasPermit('income_statement')) {
        return 2;
      }
      if (operationService.hasPermit('cash_flow_statement')) {
        return 3;
      }
      return -1;
    };
    $scope.active = activeSel();
    $scope.typeChange = function typeChange(v) {
      $scope.active = v;
    };
    $scope.typeChange(1);
    $scope.updateSearch = function () {
      $scope.$broadcast('statementType', $scope.queryParam.param.quarter);
    };
    $scope.$on('reset', (event, param) => {
      $scope.queryParam.param.quarter = utils.getQuarter();
    });
  }
}

listBannerCtrl.$inject = ['$scope', 'operationService'];
export default listBannerCtrl;



// WEBPACK FOOTER //
// ./src/app/declaration/corporateIncomeTax/smallBusinessGuidelines/listBannerCtrl.js